import { actionConst } from "../constants";
import { DeviceType } from "../types";

export const updateSphygmomanometer = (device: DeviceType) => {
  return {
    type: actionConst.CHANGE_SPHYGMOMANOMETER,
    device,
  };
};
